import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ExternalLinkButton from "src/components/Button/ExternalLinkButton";
import AuthorizationButton from "src/components/Button/AuthorizationButton";
import { THEME_MODE } from "src/config/constants";
import { formatAddress } from "src/services/utils";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

const useStyle = makeStyles((theme) => ({
  title: {
    padding: "10px 20px 10px 20px",
    background: theme.palette.type === THEME_MODE.DARK ? "#00244D" : "#F2F4F7",
  },
  more: {
    color: theme.palette.text.more,
  },
}));

export default function DisconnectedWalletDialog({ open, onClose }) {
  const cls = useStyle();
  const { address, disconnect } = useWeb3Connect();

  const onDisconnectWalletClick = () => {
    disconnect();
    onClose();
  };

  return (
    <Dialog open={open} PaperProps={{ elevation: 0, style: { maxWidth: 350, padding: "0px" } }} fullWidth>
      <DialogTitle className={cls.title}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h4">Wallet Connection</Typography>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Typography className={cls.more}>{formatAddress(address, 3)}</Typography>
          <ExternalLinkButton hash={address} />
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <AuthorizationButton variant="contained" color="secondary" onClick={onClose} />
          <Button variant="contained" color="primary" onClick={() => onDisconnectWalletClick()}>
            Disconnect
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
